import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#08080C] bg-grid flex items-center justify-center px-4" data-testid="payment-cancel-page">
      <div className="w-full max-w-lg border border-[#242436] bg-[#111118] p-10 text-center">
        <img src="/logo.webp" alt="G.A.M.E. logo" className="h-16 w-auto mx-auto rounded-sm ring-1 ring-[#FFB800]/60" />
        <h1 className="font-display font-black uppercase text-2xl text-[#F4F4F6] mt-8">Checkout cancelled</h1>
        <p className="text-sm text-[#A1A1B3] leading-relaxed mt-3">No charge was made. Your cart and your pledge are still waiting whenever you're ready.</p>
        <div className="mt-8 flex justify-center gap-4">
          <Link to="/" data-testid="cancel-home-link" className="flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] border border-[#3D3D58] px-5 py-2.5 text-[#A1A1B3] hover:border-[#8B5CF6] hover:text-[#F4F4F6] transition-colors">
            <ArrowLeft className="w-3.5 h-3.5" /> Home
          </Link>
          <Link to="/" data-testid="cancel-store-link" className="font-mono text-xs uppercase tracking-[0.2em] bg-[#8B5CF6] text-black px-5 py-2.5 hover:bg-[#FFB800] transition-colors">Back to Donate</Link>
        </div>
      </div>
    </div>
  );
}
